import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Projecttemplate } from '../model/projecttemplate';

@Injectable({
  providedIn: 'root'
})
export class OrgtemplatelistService {

  constructor(private http:HttpClient) { }

  getProjectTemplates(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	/organization/{organizationId}/template/list
    return this.http.get<Projecttemplate[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/template/list',httpOptions)
  
  }
  deleteTemplate(template:Projecttemplate){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/template/'+template.templateId,httpOptions)
  
  }
}
